import React from 'react';
import withView from '../../../../cmn/docAutomation/withView';
import FormButton from '../../../../../library/form/components/FormActionButton2';
import SarasTrans from '../../../../../library/notifications/SarasTrans';

const PRSearchBatchAction = (props) => {
    const { formObject, selectedDids, reloadSearch } = props;

    const onActionSuccess = () => {
        if(reloadSearch)reloadSearch(1);
    }

    return (
        <div className="uiFloatRight">
            <div>
                <div className="uiSpacerH15">
                    <span><SarasTrans value="Review Records" />: </span>
                    <FormButton formObject={formObject} rowKey="" className="uiActionButton uiBatchReviewApprove approve"
                        confirm="Are you sure you want to Approve the selected documents ?"
                        action={{ actionId: "save",  paramName: "batchAction", actionName: "WrkFlwApv",
                        actionMessage: "Processing Action", 
                        actionParam: {ops:1, wrkflwactionid:2, dIds:selectedDids.join(","), sdtId:"%dataList.valLDT"}, onSuccess:onActionSuccess}}
                        text={<SarasTrans value="Approve" />}></FormButton>

                    <FormButton formObject={formObject} rowKey="" className="uiActionButton uiBatchReviewReject reject"
                        confirm="Are you sure you want to Reject the selected documents ?"
                        action={{ actionId: "save",  paramName: "batchAction", actionName: "WrkFlwApv",
                        actionMessage: "Processing Action", 
                        actionParam: {ops:1, wrkflwactionid:3, dIds:selectedDids.join(","), sdtId:"%dataList.valLDT"}, onSuccess:onActionSuccess }}
                        text={<SarasTrans value="Reject" />}></FormButton>
                </div>
            <FormButton formObject={formObject} rowKey="" className="uiActionButton"
                tooltip="Create Purchase Order for the selected Purchase Request"
                action={{ actionId: "import", actionMessage: "Processing Action", actionName: "invcomp", actionParam: { tdtId: "106", is:"5", dIds:selectedDids.join(",") }, containerKey:"redirect" }}
                text={<SarasTrans value="Purchase Order" />}>
            </FormButton>
            </div >
        </div >
    )
}

export default withView(PRSearchBatchAction, "", "", 1);